import { render, staticRenderFns } from "./TermsOfServiceZHTW.vue?vue&type=template&id=181f3216&scoped=true&"
var script = {}
import style0 from "./TermsOfServiceZHTW.vue?vue&type=style&index=0&id=181f3216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f3216",
  null
  
)

export default component.exports